import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

/**
 * Wraps routes that require authentication and optional role gating.
 *
 * Usage:
 *   <Route element={<ProtectedRoute />}>              // any authenticated user
 *   <Route element={<ProtectedRoute roles={['SSL','ADMIN','UPPER_ADMIN']} />}>
 */
export default function ProtectedRoute({ roles }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <span className="text-gray-500 text-sm">Loading…</span>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
